import React from "react";
import Omdb from "./components/omdb";
import Header from "./components/Header";
import "./App.css";
const App = () => 
<main>
<Header/>
<Omdb />
</main>


export default App;



// WEBPACK FOOTER //
// ./src/App.js